module.exports = __webpack_public_path__ + "img/template-requirement.ac0a5da8.png";